// TEST
let TestBaseUrl: string = "https://elite-ib.com/ApiTesting/api/";
let TestActualUrl: string = "http://elite-ib/ar/ApiTesting";
// TEST
let isLive: boolean = false;
// LIVE
let LiveBaseUrl: string = "https://elite-ib.com/api/api/";
let LiveActualUrl: string = "http://elite-ib/";
// LIVE
export const environment = {
  production: true,
  isLive: isLive,
  baseUrl: LiveBaseUrl,
  actualUrl: LiveActualUrl,
  appName: "Elite",
  imageBaseUrl: LiveBaseUrl + "File/"
};

// Inside of the paymentForm there is LInks like the Elite icon above make sure to change it 888888.
// Note : To Switch From/To Prod/Testing Change  : (envLinks  ,<meta name="robots" content="noindex" in index.html> , { provide: APP_BASE_HREF, useValue: '/site/Elite/' }, ReWrite File links , care of iis massage when you publish (might need to change nvm use 18)) ,payment links & forms
// npm install -g gzipper *********** for html/css/js compression
